namespace RioERP.Reports {
    export interface ReferralOrderProductsRow {
        Id?: number;
        OrderId?: number;
        ProductId?: number;
        Quantity?: number;
        Cost?: number;
        GrossAmount?: number;
        DiscountAmt?: number;
        NetAmount?: number;
        TaxableAmount?: number;
        SerialKey?: string;
        HasPendrive?: boolean;
        HasBooks?: boolean;
        HasCourier?: boolean;
        DownloadUrl1?: string;
        DownloadUrl2?: string;
        IsActive?: boolean;
        InvoiceCompanyId?: number;
        FranchiseeId?: number;
        FranchiseeDiscountAmount?: number;
        FranchiseeDiscountValue?: number;
        EFranchiseeDiscountType?: number;
        EOpens?: number;
        EWatchTime?: number;
        EValidity?: number;
        EValidityType?: number;
        ValidTill?: string;
        TotalAllowedDuration?: number;
        AllowedDevices?: string;
        IsLive?: boolean;
        EAccessStatus?: number;
        IsTemplateSerialKey?: boolean;
        Note?: string;
        ESerialkeyStatus?: number;
        TaxAmount?: number;
        FranchiseeName?: string;
        ProductSpecifications?: string;
        OrderCustomerId?: number;
        OrderOrderNumber?: string;
        OrderCustomerName?: string;
        OrderCustomerEmail1?: string;
        OrderCustomerEmail2?: string;
        OrderCustomerMobile1?: string;
        OrderCustomerMobile2?: string;
        OrderBillingAddress1?: string;
        OrderBillingAddress2?: string;
        OrderBillingCity?: string;
        OrderBillingStateId?: number;
        OrderBillingPincode?: number;
        OrderShippingToName?: string;
        OrderShippingAddress1?: string;
        OrderShippingAddress2?: string;
        OrderShippingCity?: string;
        OrderShippingStateId?: number;
        OrderShippingStateName?: string;
        OrderShippingPincode?: number;
        OrderEOrderStatus?: Web.Enums.OrderStatus;
        OrderEShippingType?: number;
        OrderDiscountPer?: number;
        OrderOrderDate?: string;
        ReferredBy?: number;
        OrderESourceType?: Web.Enums.SourceType;
        OrderSourceName?: string;
        OrderEmailSendCount?: number;
        OrderIsEmailSent?: boolean;
        OrderEPaymentStatus?: number;
        OrderLastEmailSentDate?: string;
        OrderFranchiseeId?: number;
        OrderEOrderProcessBy?: number;
        OrderDiscountCoupon?: string;
        OrderDiscountAmount?: number;
        OrderGrossAmount?: number;
        OrderNetAmount?: number;
        OrderTaxableAmount?: number;
        OrderEShippingStatus?: number;
        OrderEInvoiceStatus?: number;
        OrderMailId?: number;
        OrderEPaymentType?: number;
        OrderGstin?: string;
        OrderExpectedShippingDate?: string;
        OrderEInvoiceTo?: number;
        OrderEFranchiseeDiscountType?: number;
        OrderEFranchiseeDiscount?: number;
        OrderFranchiseeDiscountValue?: number;
        OrderFranchiseeDiscountAmount?: number;
        OrderInvoiceCompanyId?: number;
        OrderShippingNote?: string;
        OrderSourceOrderNumber?: string;
        OrderIsActive?: boolean;
        OrderInsertUserId?: number;
        OrderInsertDate?: string;
        OrderUpdateUserId?: number;
        OrderUpdateDate?: string;
        OrderVendorId?: number;
        OrderTaxAmount?: number;
        OrderFreezeData?: boolean;
        OrderShippingProviderId?: number;
        ProductProductName?: string;
        ProductDescription?: string;
        ProductSkuCode?: string;
        ProductEProductType?: number;
        ProductERioplayVersion?: number;
        ProductRioplayProductCode?: string;
        ProductDownloadUrl1?: string;
        ProductDownloadUrl2?: string;
        ProductHasPenDrive?: boolean;
        ProductHasBooks?: boolean;
        ProductHasCourier?: boolean;
        ProductNote?: string;
        ProductWeight?: number;
        ProductHeight?: number;
        ProductWidth?: number;
        ProductLength?: number;
        ProductEPackingType?: number;
        ProductGrossAmount?: number;
        ProductEOpens?: number;
        ProductEWatchTime?: number;
        ProductEValidity?: number;
        ProductEValidityType?: number;
        ProductValidTill?: string;
        ProductTotalAllowedDuration?: number;
        ProductAllowSerialKeyGeneration?: boolean;
        ProductAllowedDevices?: string;
        ProductIsLive?: boolean;
        ProductProcesOrderOnPaid?: boolean;
        ProductEAccessStatus?: number;
        ProductInAppDownload?: boolean;
        ProductHasVod?: boolean;
        ProductTemplateSerialKeyId?: number;
        ProductIsActive?: boolean;
        ProductInsertUserId?: number;
        ProductInsertDate?: string;
        ProductUpdateUserId?: number;
        ProductUpdateDate?: string;
        ProductVendorId?: number;
        ProductSupportInfo?: string;
        ProductProductQueryInfo?: string;
        ProductEShippedby?: number;
        ProductActivateSerialKey?: boolean;
        ProductIsCombo?: boolean;
        ProductProductIds?: string;
        ProductWebsiteUrl?: string;
        ProductTeacherName?: string;
        ProductRioPlayTenantId?: number;
        ProductSecretkey?: string;
        InvoiceCompanyName?: string;
        InvoiceCompanyAddress?: string;
        InvoiceCompanyGstIn?: string;
        InvoiceCompanyInvoiceCode?: string;
        InvoiceCompanyIsTaxApplicable?: boolean;
        InvoiceCompanyInvoiceChangeDate?: string;
        InvoiceCompanyIsDefault?: boolean;
        InvoiceCompanyFooterNote?: string;
        InvoiceCompanyLogo1?: string;
        InvoiceCompanyLogo2?: string;
        InvoiceCompanyStampImage?: string;
    }

    export namespace ReferralOrderProductsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SerialKey';
        export const localTextPrefix = 'Reports.ReferralOrderProducts';
        export const deletePermission = 'Enquiry:EnquiryManagement:Modify';
        export const insertPermission = 'Enquiry:EnquiryManagement:Modify';
        export const readPermission = 'Enquiry:EnquiryManagement:View';
        export const updatePermission = 'Enquiry:EnquiryManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            ProductId = "ProductId",
            Quantity = "Quantity",
            Cost = "Cost",
            GrossAmount = "GrossAmount",
            DiscountAmt = "DiscountAmt",
            NetAmount = "NetAmount",
            TaxableAmount = "TaxableAmount",
            SerialKey = "SerialKey",
            HasPendrive = "HasPendrive",
            HasBooks = "HasBooks",
            HasCourier = "HasCourier",
            DownloadUrl1 = "DownloadUrl1",
            DownloadUrl2 = "DownloadUrl2",
            IsActive = "IsActive",
            InvoiceCompanyId = "InvoiceCompanyId",
            FranchiseeId = "FranchiseeId",
            FranchiseeDiscountAmount = "FranchiseeDiscountAmount",
            FranchiseeDiscountValue = "FranchiseeDiscountValue",
            EFranchiseeDiscountType = "EFranchiseeDiscountType",
            EOpens = "EOpens",
            EWatchTime = "EWatchTime",
            EValidity = "EValidity",
            EValidityType = "EValidityType",
            ValidTill = "ValidTill",
            TotalAllowedDuration = "TotalAllowedDuration",
            AllowedDevices = "AllowedDevices",
            IsLive = "IsLive",
            EAccessStatus = "EAccessStatus",
            IsTemplateSerialKey = "IsTemplateSerialKey",
            Note = "Note",
            ESerialkeyStatus = "ESerialkeyStatus",
            TaxAmount = "TaxAmount",
            FranchiseeName = "FranchiseeName",
            ProductSpecifications = "ProductSpecifications",
            OrderCustomerId = "OrderCustomerId",
            OrderOrderNumber = "OrderOrderNumber",
            OrderCustomerName = "OrderCustomerName",
            OrderCustomerEmail1 = "OrderCustomerEmail1",
            OrderCustomerEmail2 = "OrderCustomerEmail2",
            OrderCustomerMobile1 = "OrderCustomerMobile1",
            OrderCustomerMobile2 = "OrderCustomerMobile2",
            OrderBillingAddress1 = "OrderBillingAddress1",
            OrderBillingAddress2 = "OrderBillingAddress2",
            OrderBillingCity = "OrderBillingCity",
            OrderBillingStateId = "OrderBillingStateId",
            OrderBillingPincode = "OrderBillingPincode",
            OrderShippingToName = "OrderShippingToName",
            OrderShippingAddress1 = "OrderShippingAddress1",
            OrderShippingAddress2 = "OrderShippingAddress2",
            OrderShippingCity = "OrderShippingCity",
            OrderShippingStateId = "OrderShippingStateId",
            OrderShippingStateName = "OrderShippingStateName",
            OrderShippingPincode = "OrderShippingPincode",
            OrderEOrderStatus = "OrderEOrderStatus",
            OrderEShippingType = "OrderEShippingType",
            OrderDiscountPer = "OrderDiscountPer",
            OrderOrderDate = "OrderOrderDate",
            ReferredBy = "ReferredBy",
            OrderESourceType = "OrderESourceType",
            OrderSourceName = "OrderSourceName",
            OrderEmailSendCount = "OrderEmailSendCount",
            OrderIsEmailSent = "OrderIsEmailSent",
            OrderEPaymentStatus = "OrderEPaymentStatus",
            OrderLastEmailSentDate = "OrderLastEmailSentDate",
            OrderFranchiseeId = "OrderFranchiseeId",
            OrderEOrderProcessBy = "OrderEOrderProcessBy",
            OrderDiscountCoupon = "OrderDiscountCoupon",
            OrderDiscountAmount = "OrderDiscountAmount",
            OrderGrossAmount = "OrderGrossAmount",
            OrderNetAmount = "OrderNetAmount",
            OrderTaxableAmount = "OrderTaxableAmount",
            OrderEShippingStatus = "OrderEShippingStatus",
            OrderEInvoiceStatus = "OrderEInvoiceStatus",
            OrderMailId = "OrderMailId",
            OrderEPaymentType = "OrderEPaymentType",
            OrderGstin = "OrderGstin",
            OrderExpectedShippingDate = "OrderExpectedShippingDate",
            OrderEInvoiceTo = "OrderEInvoiceTo",
            OrderEFranchiseeDiscountType = "OrderEFranchiseeDiscountType",
            OrderEFranchiseeDiscount = "OrderEFranchiseeDiscount",
            OrderFranchiseeDiscountValue = "OrderFranchiseeDiscountValue",
            OrderFranchiseeDiscountAmount = "OrderFranchiseeDiscountAmount",
            OrderInvoiceCompanyId = "OrderInvoiceCompanyId",
            OrderShippingNote = "OrderShippingNote",
            OrderSourceOrderNumber = "OrderSourceOrderNumber",
            OrderIsActive = "OrderIsActive",
            OrderInsertUserId = "OrderInsertUserId",
            OrderInsertDate = "OrderInsertDate",
            OrderUpdateUserId = "OrderUpdateUserId",
            OrderUpdateDate = "OrderUpdateDate",
            OrderVendorId = "OrderVendorId",
            OrderTaxAmount = "OrderTaxAmount",
            OrderFreezeData = "OrderFreezeData",
            OrderShippingProviderId = "OrderShippingProviderId",
            ProductProductName = "ProductProductName",
            ProductDescription = "ProductDescription",
            ProductSkuCode = "ProductSkuCode",
            ProductEProductType = "ProductEProductType",
            ProductERioplayVersion = "ProductERioplayVersion",
            ProductRioplayProductCode = "ProductRioplayProductCode",
            ProductDownloadUrl1 = "ProductDownloadUrl1",
            ProductDownloadUrl2 = "ProductDownloadUrl2",
            ProductHasPenDrive = "ProductHasPenDrive",
            ProductHasBooks = "ProductHasBooks",
            ProductHasCourier = "ProductHasCourier",
            ProductNote = "ProductNote",
            ProductWeight = "ProductWeight",
            ProductHeight = "ProductHeight",
            ProductWidth = "ProductWidth",
            ProductLength = "ProductLength",
            ProductEPackingType = "ProductEPackingType",
            ProductGrossAmount = "ProductGrossAmount",
            ProductEOpens = "ProductEOpens",
            ProductEWatchTime = "ProductEWatchTime",
            ProductEValidity = "ProductEValidity",
            ProductEValidityType = "ProductEValidityType",
            ProductValidTill = "ProductValidTill",
            ProductTotalAllowedDuration = "ProductTotalAllowedDuration",
            ProductAllowSerialKeyGeneration = "ProductAllowSerialKeyGeneration",
            ProductAllowedDevices = "ProductAllowedDevices",
            ProductIsLive = "ProductIsLive",
            ProductProcesOrderOnPaid = "ProductProcesOrderOnPaid",
            ProductEAccessStatus = "ProductEAccessStatus",
            ProductInAppDownload = "ProductInAppDownload",
            ProductHasVod = "ProductHasVod",
            ProductTemplateSerialKeyId = "ProductTemplateSerialKeyId",
            ProductIsActive = "ProductIsActive",
            ProductInsertUserId = "ProductInsertUserId",
            ProductInsertDate = "ProductInsertDate",
            ProductUpdateUserId = "ProductUpdateUserId",
            ProductUpdateDate = "ProductUpdateDate",
            ProductVendorId = "ProductVendorId",
            ProductSupportInfo = "ProductSupportInfo",
            ProductProductQueryInfo = "ProductProductQueryInfo",
            ProductEShippedby = "ProductEShippedby",
            ProductActivateSerialKey = "ProductActivateSerialKey",
            ProductIsCombo = "ProductIsCombo",
            ProductProductIds = "ProductProductIds",
            ProductWebsiteUrl = "ProductWebsiteUrl",
            ProductTeacherName = "ProductTeacherName",
            ProductRioPlayTenantId = "ProductRioPlayTenantId",
            ProductSecretkey = "ProductSecretkey",
            InvoiceCompanyName = "InvoiceCompanyName",
            InvoiceCompanyAddress = "InvoiceCompanyAddress",
            InvoiceCompanyGstIn = "InvoiceCompanyGstIn",
            InvoiceCompanyInvoiceCode = "InvoiceCompanyInvoiceCode",
            InvoiceCompanyIsTaxApplicable = "InvoiceCompanyIsTaxApplicable",
            InvoiceCompanyInvoiceChangeDate = "InvoiceCompanyInvoiceChangeDate",
            InvoiceCompanyIsDefault = "InvoiceCompanyIsDefault",
            InvoiceCompanyFooterNote = "InvoiceCompanyFooterNote",
            InvoiceCompanyLogo1 = "InvoiceCompanyLogo1",
            InvoiceCompanyLogo2 = "InvoiceCompanyLogo2",
            InvoiceCompanyStampImage = "InvoiceCompanyStampImage"
        }
    }
}
